import * as log from 'app/log';
// @ts-expect-error FIXME:
export function logger(store) {
  // @ts-expect-error FIXME:
  return (next) => {
    // @ts-expect-error FIXME:
    return (action) => {
      log.info('dispatching:', action);
      const result = next(action);
      log.debug('next state:', store.getState());
      return result;
    };
  };
}
